import { gql } from "@apollo/client";

const DELETE_LEAGUE = gql`
  mutation softDeleteLeague($id: Float!) {
    softDeleteLeague(id: $id) {
      id
    }
  }
`;

export default DELETE_LEAGUE;
